import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
} from "@heroicons/react/24/outline";
import Container from "../Common/Container";
import { Testimonial, TestimonialsProps } from "./interfaces/Testimonials";
import Text from "../Common/Text";
const DEFAULTDATA = {
  testimonials: [
    {
      id: "53ed421c-c32e-992f-7ba2-c5153d02714d",
      logo: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/8f63172e-32b5-4d6f-9c69-97e05fccab92.png",
      },
      photo: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/71fb7f90-acca-4c0a-9a32-6ef12a6aa270.webp",
      },
      description: {
        value:
          '"¡Increíble experiencia con Dogtorsoftware! La interfaz fácil de usar y las potentes herramientas de edición han transformado por completo la forma en que gestiono mi contenido. ¡Altamente recomendado para cualquier persona que busque simplicidad y eficacia!"',
      },
      name: "Sara Torres",
      rol: "CEO",
    },
    {
      id: "bf5a8226-d235-3e09-60e3-3b7ef0179886",
      logo: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/eb76b24d-0003-4e3d-b344-6cf7db08773c.png",
      },
      photo: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/0af8f1d9-45c8-49c9-af50-709902df49d9.jpg",
      },
      description: {
        value:
          '"Dogtorsoftware ha sido una herramienta invaluable para nuestra empresa. La gestión eficiente de contenido, combinada con la seguridad sólida, nos ha brindado la confianza necesaria para construir una presencia en línea sólida. ¡Gracias por simplificar nuestro viaje digital!"',
      },
      name: "Jhon Doe",
      rol: "Emprendedor",
    },
  ],
  time: "3",
};

const Testimonials = ({
  data = DEFAULTDATA,
  onChange,
}: {
  data: TestimonialsProps;
  onChange: (value: any, id?: string) => void;
}) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplaySpeed: parseInt(data?.time || "2", 10) * 1000,
    autoplay: true,
    slidesToShow: parseInt(data?.total || "2", 10),
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <ArrowRight />,
    prevArrow: <ArrowLeft />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
        },
      },
    ],
  };

  if (data?.testimonials?.length == 1) {
    return (
      <Container>
        <Slide item={data?.testimonials?.[0]} onChange={onChange} data={data} />
      </Container>
    );
  }

  return (
    <div className="my-10">
      <Container>
        <div className="slider-container">
          <Slider {...settings}>
            {data?.testimonials?.map((item) => (
              <Slide
                key={item.id}
                item={item}
                data={data}
                onChange={onChange}
              />
            ))}
          </Slider>
        </div>
      </Container>
    </div>
  );
};

const Slide = ({
  item,
  onChange,
  data,
}: {
  item: Testimonial;
  onChange: (value: any, id?: string) => void;
  data: TestimonialsProps;
}) => {
  return (
    <section className="relative isolate overflow-hidden bg-white px-6 ">
      {item?.logo && (
        <img className="mx-auto h-12" src={item.logo?.desktop} alt="" />
      )}
      <figure className="mt-5">
        <Text
          editor={!!onChange}
          id="Testimonials"
          onChange={(val: any) => {
            if (onChange) {
              let arr = data?.testimonials;

              arr = arr?.map((x) => {
                if (x.id === item.id) {
                  return { ...x, description: val };
                }
                return x;
              });
              onChange?.(arr, "testimonials");
            }
          }}
        >
          {item?.description}
        </Text>

        <figcaption className="mt-5">
          {item?.photo && (
            <img
              className="mx-auto h-10 w-10 rounded-full bg-cover bg-center"
              src={item?.photo?.desktop}
              alt=""
            />
          )}
          <div className="mt-4 flex items-center justify-center space-x-3 text-base">
            <div className="font-semibold text-gray-900">{item?.name}</div>
            <svg
              viewBox="0 0 2 2"
              width={3}
              height={3}
              aria-hidden="true"
              className="fill-gray-900"
            >
              <circle cx={1} cy={1} r={1} />
            </svg>
            <div className="text-gray-600">{item?.rol}</div>
          </div>
        </figcaption>
      </figure>
    </section>
  );
};

const ArrowRight = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <ArrowRightCircleIcon
      aria-hidden="true"
      className={`${className} `}
      onClick={onClick}
      style={{
        ...style,
        display: "block",
        color: "var(--primary900)",
        width: "30px",
        height: "30px",
      }}
    />
  );
};
const ArrowLeft = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <ArrowLeftCircleIcon
      aria-hidden="true"
      className={`${className} `}
      onClick={onClick}
      style={{
        ...style,
        display: "block",
        color: "var(--primary900)",
        width: "30px",
        height: "30px",
      }}
    />
  );
};

export default Testimonials;
